const MultiEmailsComponent = {
  template: require('./multi-emails.html'),
  restrict: 'E',
  bindings: {
    formatContact: '=',
    emails: '<',
    name: '@',
    maxEmails: '=?',
    onEmailChange: '&'
  },
  controller: MultiEmailsController,
  controllerAs: 'vm'
};

function MultiEmailsController($scope, gettextCatalog) {
  'ngInject';

  const vm = this;

  vm.emailsModel = [];
  vm.maxEmails = vm.maxEmails ? vm.maxEmails : 10;
  vm.placeholdertxt = gettextCatalog.getString('Enter up to {{emailsnum}} email {{msgText}} separated by a comma (,)', {
    emailsnum: vm.maxEmails,
    msgText: vm.maxEmails > 1 ? gettextCatalog.getString('addresses') : gettextCatalog.getString('address')
  });

  $scope.$watchCollection('vm.emails', emails => {
    if (emails ) {
      generateEmails();
    }
  });

  const generateEmails = () => {
    vm.emailsModel = [];

    vm.emails.forEach(value => {
      vm.formatContact ? vm.emailsModel.push({
        text: value.email
      }) : vm.emailsModel.push({
        text: value
      });
    });
  };

  vm.updateTags = () => {
    const result = [];

    vm.emailsModel.forEach(email => {
      vm.formatContact ? result.push({
        email: email.text
      }) : result.push(email.text);
    });

    if (result.length > vm.maxEmails) {
      $scope.$emit('totalEmails', {
        length: vm.maxEmails
      });
    }

    vm.onEmailChange({
      $event: {
        emails: result
      }
    });
  };
}

export default MultiEmailsComponent;